var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreProblemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9837 14.1108C31.6823 13.4122 32.0633 12.4869 32.0633 11.4981C32.0633 10.5092 31.6823 9.57483 30.9837 8.87628L27.8267 5.71926C26.3752 4.27685 24.0347 4.27685 22.5922 5.71926L20.0703 8.24125L28.4618 16.6327L30.9837 14.1108Z",
    fill: "#FF3F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30043 32.7625C5.36394 32.7625 5.42746 32.7625 5.49097 32.7534L13.0024 31.7011C13.2928 31.6648 13.5649 31.5287 13.7736 31.32L26.5376 18.5559L18.1461 10.1646L5.38214 22.9286C5.1734 23.1373 5.03738 23.4094 5.00105 23.6997L3.94877 31.2112C3.89429 31.6376 4.03946 32.064 4.33884 32.3633C4.59278 32.6173 4.93753 32.7625 5.30043 32.7625Z",
    fill: "#FFC22E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreProblemIcon);
export default __webpack_public_path__ + "static/media/gre-problem-icon.60602db63926c3358028a9747585d069.svg";
export { ForwardRef as ReactComponent };